import React from 'react'
import Moment from 'react-moment'
import NumberFormat from 'react-number-format'
import { Icon } from 'semantic-ui-react'
import { StatusTag, DivText } from './styled'

export const options = {
  listSize: [
    { text: '30', value: 30 },
    { text: '60', value: 60 },
    { text: '90', value: 90 },
    { text: '120', value: 120 }
  ],
} 

const prStatus = {0:'Draft',2:'In Progress',3:'Revise',4:'Completed',5:'Reject',6:'Cancelled'}

export const columns = { 
  tEditItem:[
    {
      Header: 'Action',
      accessor: 'id',
      width: 120,
      Cell: row => (
        <div style={{display:'flex'}}>
          <Icon name='edit' circular link/>
          <Icon name='copy' circular link/>
          <Icon name='trash' circular link/>
        </div>
      )
    },{
      Header: 'No.',
      accessor: 'lineNo',
      width: 100,
    },{
      Header: 'Name',
      accessor: 'itemName',
      width: 100,
    },{
      Header: 'Description',
      accessor: 'itemDescription',
      width: 100,
    },{
      Header: 'Quantity',
      accessor: 'quantity',
      width: 100,
    },{
      Header: 'Unit',
      accessor: 'unit',
      width: 100,
    },{
      Header: 'Unit Price(Ex.VAT)',
      accessor: 'unitPrice',
      width: 100,
    },{
      Header: 'Currency',
      accessor: 'currency',
      width: 100,
    },{
      Header: 'Total Amount(Ex.VAT)',
      accessor: 'totalAmount',
      width: 100,
    },{
      Header: 'Budget Type',
      accessor: 'budgetType',
      width: 100,
    },{
      Header: 'Cost Center',
      accessor: 'costCenter',
      width: 100,
    },{
      Header: 'GL Account',
      accessor: 'GLAccountCode',
      width: 100,
    },{
      Header: 'Acc. Assa',
      accessor: 'AccountAssignmentCategoryCode',
      width: 100,
    },{
      Header: 'StartDate',
      accessor: 'startDate',
      width: 100,
      Cell: row => (
        <DivText>
          {row.value?
            <Moment format="DD MMM YYYY HH:mm">{row.value}</Moment>
            :
            '-'
          }
        </DivText>)
    },{
      Header: 'Delivery Date/Finish Date',
      accessor: 'deliveryDate',
      width: 100,
      Cell: row => (
        <DivText>
          {row.value?
            <Moment format="DD MMM YYYY HH:mm">{row.value}</Moment>
            :
            '-'
          }
        </DivText>)
    },{
      Header: 'Plant',
      accessor: 'plant',
      width: 100,
    },{
      Header: 'StorageLocation',
      accessor: 'storageLocation',
      width: 100,
    },{
      Header: 'Purchasing Group',
      accessor: 'purchasingGroup',
      width: 100,
    },{
      Header: 'Material Group',
      accessor: 'materialGroup',
      width: 100,
    }
  ],
  tPRs: (companies) =>{
    return ([
      {
        Header: 'Status',
        accessor: 'status',
        width: 110,
        Cell:row=>(<DivText><StatusTag status={row.value}>{prStatus[row.value]}</StatusTag></DivText>)
      },{
        Header: 'Doc No.',
        accessor : row =>(row.status === 0 ? '-' : row.docNo),
        id:'docNo',
        width: 100,
        Cell:row=>(<DivText>{row.value}</DivText>)
      }, {
        Header: ()=>(<DivText left>Title</DivText>),
        accessor : row =>(row.title.trim()),
        id:'title',
        width: 350
      }, {
        Header: ()=>(<DivText left>Project name</DivText>),
        accessor: 'projectName',
        width: 120
      }, {
        Header: ()=>(<DivText left>Company</DivText>),
        id:'company',
        accessor : row =>{
          let x = null 
          if(companies.length>0){
            x = companies.find(x=>x.value==row.companyCode)
          }
          return (x?x.text:`${row.companyCode}`)
        },
        width: 240
      }, {
        Header: 'Priority',
        accessor: 'priority',
        width: 70,
        Cell: row => (
          row.value && 
          <DivText><div className={`priority ${row.value}`}>{row.value.toUpperCase()}</div></DivText>)
      },{
        Header: 'Current Activity',
        accessor: 'statusActivity',
        width: 120,
      },{
        Header: ()=>(<DivText left>Requester</DivText>),
        accessor: 'requesterName',
        width: 100,
        Cell: row => (row.value&&<DivText left>{`${row.value||'-'}`}</DivText>)
      },
      // {
      //   Header: 'Overdue',
      //   id:'overdue',
      //   accessor : row =>(Math.floor(row.pendingDays-row.slaDays)),
      //   width: 70,
      //   Cell: row => (<DivText>{`${ row.value>=1?`(${row.value} days)`:'-'}`}</DivText>)
      // }, 
      {
        Header: 'Submitted date',
        accessor: 'submittedDate',
        width: 120,
        Cell: row => (row.value&&
          <DivText>
            {row.value?
              <Moment format="DD MMM YYYY HH:mm">{row.value}</Moment>
              :
              '-'
            }
          </DivText>)
      }, {
        Header: 'Modified date',
        accessor: 'modifiedDate',
        width: 120,
        Cell: row => (row.value&&<DivText><Moment format="DD MMM YYYY HH:mm">{row.value}</Moment></DivText>)
      }
    ])
  },
  tSummary: [
    {
      Header: 'Code',
      accessor: 'code',
      width: 150
    }, {
      Header: 'Description',
      accessor: 'description',
      width: 150
    }, {
      Header: 'Code2',
      accessor: 'code2',
      width: 150
    }, {
      Header: 'Description',
      accessor: 'description2',
      width: 150
    }, {
      Header: 'Plan',
      accessor: 'plan',
      width: 150,
      Cell: row => (<NumberFormat value={row.value} displayType={'text'} thousandSeparator={true}/>)
    }, {
      Header: 'Actual',
      accessor: 'actual',
      width: 150,
      Cell: row => (<NumberFormat value={row.value} displayType={'text'} thousandSeparator={true}/>)
    }, {
      Header: 'Commitment',
      accessor: 'commitment',
      width: 150,
      Cell: row => (<NumberFormat value={row.value} displayType={'text'} thousandSeparator={true}/>)
    }, {
      Header: 'Assigned',
      accessor: 'assigned',
      width: 150,
      Cell: row => (<NumberFormat value={row.value} displayType={'text'} thousandSeparator={true}/>)
    }, {
      Header: 'Available',
      accessor: 'available',
      width: 150,
      Cell: row => (<NumberFormat value={row.value} displayType={'text'} thousandSeparator={true}/>)
    }, {
      Header: 'Currency',
      accessor: 'currency',
      width: 150
    }, {
      Header: 'Modify Date',
      accessor: 'modifiedDate',
      width: 100,
      Cell: row => (<Moment format="DD MMM YYYY">{row.value}</Moment>)
    }
  ],
  tBudget:[
    {
      Header: 'Code',
      accessor: 'code',
      width: 150
    },
    {
      Header: 'Description',
      accessor: 'description',
      width: 150
    },
    {
      Header: 'Code2/GL Account',
      accessor: 'code2',
      width: 150
    },
    {
      Header: 'Description',
      accessor: 'description2',
      width: 150
    },
    {
      Header: 'Plan/Budget',
      accessor: 'plan',
      width: 150,
      Cell: row => (<NumberFormat value={row.value} displayType={'text'} thousandSeparator={true}/>)
    },
    {
      Header: 'Actual',
      accessor: 'actual',
      width: 150,
      Cell: row => (<NumberFormat value={row.value} displayType={'text'} thousandSeparator={true}/>)
    },
    {
      Header: 'Commitment',
      accessor: 'commitment',
      width: 150,
      Cell: row => (<NumberFormat value={row.value} displayType={'text'} thousandSeparator={true}/>)
    },
    {
      Header: 'Assigned',
      accessor: 'assigned',
      width: 150,
      Cell: row => (<NumberFormat value={row.value} displayType={'text'} thousandSeparator={true}/>)
    },
    {
      Header: 'Available',
      accessor: 'available',
      width: 150,
      Cell: row => (<NumberFormat value={row.value} displayType={'text'} thousandSeparator={true}/>)
    },
    {
      Header: 'Currency',
      accessor: 'currency',
      width: 150
    },
  ],
  tDetail:[
    {
      Header: 'No.',
      accessor: 'lineNo',
      width: 40
    },
    {
      Header: 'Item Name',
      accessor: 'itemName',
      width: 150
    },
    {
      Header: 'Item Description',
      accessor: 'itemDescription',
      width: 150
    },
    {
      Header: 'Unit',
      accessor: 'unit',
      width: 150
    },
    {
      Header: 'Quantity',
      accessor: 'quantity',
      width: 150
    },
    {
      Header: 'Currency',
      accessor: 'currency',
      width: 150
    },
    {
      Header: 'Unit Price Estimated (Ex.VAT)',
      accessor: 'unitPrice',
      width: 150,
      Cell: row => (<NumberFormat value={row.value} displayType={'text'} thousandSeparator={true}/>)
    },
    {
      Header: 'Total Amount Estimated (Ex.VAT)',
      accessor: 'totalAmount',
      width: 150,
      Cell: row => (<NumberFormat value={row.value} displayType={'text'} thousandSeparator={true}/>)
    },
    {
      Header: 'Budget Type',
      accessor: 'budgetType',
      width: 150
    },
    {
      Header: 'Cost Center',
      accessor: 'costCenter',
      width: 150
    },
    {
      Header: 'WBS',
      accessor: 'wbs',
      width: 150
    },
    {
      Header: 'GL Account',
      accessor: 'glAccountCode',
      width: 150
    },
    {
      Header: 'Acc Assc',
      accessor: 'accountAssc',
      width: 150
    },
    {
      Header: 'Start Date',
      accessor: 'startDate',
      width: 150,
      Cell: row => (<Moment format="DD MMM YYYY">{row.value}</Moment>)
    },
    {
      Header: 'Delivery Date/Finish Date',
      accessor: 'deliveryDate',
      width: 150,
      Cell: row => (<Moment format="DD MMM YYYY">{row.value}</Moment>)
    },
    {
      Header: 'Plant',
      accessor: 'plant',
      width: 150
    },
    {
      Header: 'Storage Location',
      accessor: 'storageLocation',
      width: 150
    },
    {
      Header: 'Purchasing Org',
      accessor: 'purchasingOrg',
      width: 150
    },
    {
      Header: 'Material Group',
      accessor: 'materialGroup',
      width: 150
    }
  ]
}

export const AdditionalRemark = () => {
  return (
    <div className='rowFields' style={{ flexDirection: 'column' }}>
      <div style={{ fontWeight: 'bold', textDecoration: 'underline' }}>ขอบเขตงานเพิ่ม:</div>
      <ul>
        <li>งานที่ทำตามขอบเขตหรือเนื้องานเดิมของ PO หลัก/สัญญาหลัก</li>
        <li>งานที่มีขอบเขตงานต่อเนื่องจาก PO หลัก/สัญญาหลัก ไม่สามารถให้รายอื่นทำแทนได้</li>
        <li>งานที่ไม่ใช่เนื้องานเดิมแต่ทำในพื้นที่เดิม ให้เลือก Special PR > เหตุผลอื่นๆ > การจัดซื้อสินค้าหรือการจัดจ้างบริการที่เป็นการจัดซื้อจัดจ้างงานต่อเนื่องพื้นที่โครงการเดิม โดยเป็นขอบเขตงานใหม่</li>
      </ul>
    </div>
  )
}